import * as React from 'react';
import { Tabs as Tabs$1, TabList, Tab as Tab$1, TabPanels, TabPanel } from '@reach/tabs';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Tabs container.
 */
var Tabs = function Tabs(_ref) {
  var centered = _ref.centered,
      justified = _ref.justified,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["centered", "justified", "className", "children"]);

  return /*#__PURE__*/React.createElement(Tabs$1, _extends({
    className: classNames('tabs', className)
  }, props), /*#__PURE__*/React.createElement(TabList, {
    as: "ul",
    className: classNames('tabs__control', {
      'tabs__control--centered': centered,
      'tabs__control--justified': justified
    })
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement(Tab$1, {
      as: "li",
      className: "tabs__control__tab"
    }, child.props.title);
  })), /*#__PURE__*/React.createElement(TabPanels, null, React.Children.map(children, function (child) {
    // Destructuring here to get rid of the values that only to tabs, not the content
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _child$props = child.props;
        _child$props.title;
        var props = _objectWithoutPropertiesLoose(_child$props, ["title"]);

    return /*#__PURE__*/React.createElement(TabPanel, _extends({
      className: "tabs__content"
    }, props));
  })));
};
Tabs.displayName = "Tabs";

/**
 * A tab. Should only be rendered inside `<Tabs>`.
 */
var Tab = function Tab(props) {
  return null;
}; // Don't render anything here. To simplify the surface API we simply use this component as a data container.
// We do the rendering in <Tabs>.

export { Tab, Tabs };
//# sourceMappingURL=index.es.js.map
